import * as workflowDefinitonApi from '../../../../../api/administration/workflowDefinitionApi';
import * as actionTypes from './actionTypes';

export function fetchSuccess(workflowDefinitions) {
  return {
    type: actionTypes.FETCH_WORKFLOW_DEFINITIONS_SUCCESS,
    workflowDefinitions: workflowDefinitions,
  };
}

export function fetchFailure(error) {
  return {
    type: actionTypes.FETCH_WORKFLOW_DEFINITIONS_FAILURE,
    error: {
      name: error.name,
      message: error.message,
    },
  };
}

export function setFetchRequestLoading(isLoading) {
  return {
    type: actionTypes.SET_WORKFLOW_DEFINITIONS_FETCH_REQUEST_LOADING,
    loading: isLoading,
  };
}

export function fetchWorkflowDefinitions() {
  return (dispatch, getState) => {
    const { accountId } = getState().internalReducer.internal;

    // we're about to do an async fetch, set the loading state to true
    dispatch(setFetchRequestLoading(true));

    return workflowDefinitonApi
      .getWorkflowDefinitions(accountId)
      .then((response) => {
        dispatch(fetchSuccess(response.data));
        dispatch(setFetchRequestLoading(false));
      })
      .catch((error) => {
        dispatch(fetchFailure(error));
        dispatch(setFetchRequestLoading(false));
      });
  };
}
